import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
	private handlers: Map<string, DetachedRouteHandle> = new Map();

	shouldDetach(route: ActivatedRouteSnapshot): boolean {
		return route.data && route.data.reuse;
	}

	store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
		this.handlers.set(this.getRouteUrl(route), handle);
	}

	shouldAttach(route: ActivatedRouteSnapshot): boolean {
		return this.handlers.has(this.getRouteUrl(route));
	}

	retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
		if (!route.routeConfig) {
			return null;
		}
		return this.handlers.get(this.getRouteUrl(route));
	}

	shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
		return future.routeConfig === curr.routeConfig && JSON.stringify(future.params) === JSON.stringify(curr.params);
	}

	private getRouteUrl(route: ActivatedRouteSnapshot): string {
		return route['_routerState'].url.replace(/\//g, '_');
	}
}
